var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    { attrs: { sm12: "", md12: "" } },
    [
      _c(
        "v-layout",
        {
          staticClass: "mb-1",
          attrs: { row: "", wrap: "", "align-center": "", "justify-center": "" }
        },
        [
          _c("v-flex", { attrs: { xs12: "" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "center",
                  "align-items": "center"
                }
              },
              [
                _c(
                  "h2",
                  {
                    staticClass: "h2_title",
                    staticStyle: {
                      "margin-right": "16px",
                      "font-weight": "normal"
                    }
                  },
                  [
                    _vm._v(
                      "\n          Detalle de Serie " +
                        _vm._s(_vm.patente) +
                        " - Estado: " +
                        _vm._s(_vm.estado) +
                        "\n        "
                    )
                  ]
                ),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      color: "#ffe800",
                      disabled: _vm.estado === "Finalizado"
                    },
                    on: {
                      click: function($event) {
                        return _vm.showConfirmation("finalizar")
                      }
                    }
                  },
                  [_vm._v("Finalizar")]
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-container",
        {
          staticClass: "pa-0",
          staticStyle: {
            "padding-top": "0px",
            "min-height": "calc(100vh - 5px)"
          },
          attrs: { "grid-list-md": "", fluid: "" }
        },
        [
          _c(
            "div",
            { staticStyle: { position: "relative", "min-height": "400px" } },
            [
              _vm.isLoading
                ? _c("div", {
                    staticClass: "loader",
                    staticStyle: {
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)"
                    }
                  })
                : _vm._e(),
              !_vm.isLoading
                ? _c(
                    "div",
                    [
                      _c(
                        "v-layout",
                        {
                          staticClass: "ma-0 pa-0 mb-3",
                          attrs: {
                            row: "",
                            wrap: "",
                            "align-center": "",
                            "justify-center": ""
                          }
                        },
                        [
                          _vm.datosComparativa
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", sm8: "", md10: "" } },
                                [
                                  _c("div", { staticClass: "fake-table" }, [
                                    _c("div", { staticClass: "table-header" }, [
                                      _c("div", { staticClass: "header-item" }),
                                      _c(
                                        "div",
                                        { staticClass: "header-item" },
                                        [_vm._v("Orden de Servicio")]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "header-item" },
                                        [_vm._v("CRM")]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "header-item" },
                                        [
                                          _vm._v("\n                  AVL:"),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.datosPlataforma
                                                  ? _vm.datosPlataforma
                                                  : "No disponible"
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    ]),
                                    _c("div", { staticClass: "table-row" }, [
                                      _c("div", { staticClass: "row-item" }, [
                                        _vm._v("Cliente")
                                      ]),
                                      _c("div", {
                                        staticClass: "row-item",
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.datosComparativa.OS.nombre +
                                              " (" +
                                              _vm.datosComparativa.OS
                                                .clienterut +
                                              ")"
                                          )
                                        }
                                      }),
                                      _c("div", {
                                        staticClass: "row-item",
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.datosComparativa.CRM
                                              .razon_social
                                          )
                                        }
                                      }),
                                      _c("div", {
                                        staticClass: "row-item",
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.datosComparativa.AVL.cliente
                                          )
                                        }
                                      })
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "table-row" },
                                      [
                                        _c("div", { staticClass: "row-item" }, [
                                          _vm._v("Patente")
                                        ]),
                                        _c("EditOrderServicioColumn", {
                                          attrs: {
                                            columnValue:
                                              _vm.datosComparativa.OS
                                                .patente_vehiculo,
                                            columnToEdit: "patente",
                                            patente: _vm.patente
                                          }
                                        }),
                                        _c("div", {
                                          staticClass: "row-item",
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.datosComparativa.CRM.patente
                                            )
                                          }
                                        }),
                                        _c("div", {
                                          staticClass: "row-item",
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.datosComparativa.OS
                                                .patente_vehiculo
                                            )
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "table-row" },
                                      [
                                        _c("div", { staticClass: "row-item" }, [
                                          _vm._v("Marca")
                                        ]),
                                        _c("EditOrderServicioColumn", {
                                          attrs: {
                                            columnValue:
                                              _vm.datosComparativa.OS
                                                .altaser_marca_vehiculo,
                                            columnToEdit: "marca",
                                            patente: _vm.patente
                                          }
                                        }),
                                        _c("div", {
                                          staticClass: "row-item",
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.datosComparativa.CRM.marca
                                            )
                                          }
                                        }),
                                        _c("div", { staticClass: "row-item" })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "table-row" },
                                      [
                                        _c("div", { staticClass: "row-item" }, [
                                          _vm._v("Modelo")
                                        ]),
                                        _c("EditOrderServicioColumn", {
                                          attrs: {
                                            columnValue:
                                              _vm.datosComparativa.OS
                                                .altaser_modelo_vehiculo,
                                            columnToEdit: "modelo",
                                            patente: _vm.patente
                                          }
                                        }),
                                        _c("div", {
                                          staticClass: "row-item",
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.datosComparativa.CRM.modelo
                                            )
                                          }
                                        }),
                                        _c("div", { staticClass: "row-item" })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "table-row" },
                                      [
                                        _c("div", { staticClass: "row-item" }, [
                                          _vm._v("Año")
                                        ]),
                                        _c("EditOrderServicioColumn", {
                                          attrs: {
                                            columnValue:
                                              _vm.datosComparativa.OS
                                                .altaser_anio_vehiculo,
                                            columnToEdit: "anio",
                                            patente: _vm.patente
                                          }
                                        }),
                                        _c("div", {
                                          staticClass: "row-item",
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.datosComparativa.CRM.year
                                            )
                                          }
                                        }),
                                        _c("div", { staticClass: "row-item" })
                                      ],
                                      1
                                    ),
                                    _c("div", { staticClass: "table-row" }, [
                                      _c("div", { staticClass: "row-item" }, [
                                        _vm._v("SIM")
                                      ]),
                                      _c("div", {
                                        staticClass: "row-item",
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.datosComparativa.OS
                                              .simserienumero
                                          )
                                        }
                                      }),
                                      _c("div", {
                                        staticClass: "row-item",
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.datosComparativa.CRM.sim
                                          )
                                        }
                                      }),
                                      _c("div", {
                                        staticClass: "row-item",
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.datosComparativa.AVL.sim
                                          )
                                        }
                                      })
                                    ]),
                                    _c("div", { staticClass: "table-row" }, [
                                      _c("div", { staticClass: "row-item" }, [
                                        _vm._v("Fecha Instalación")
                                      ]),
                                      _c("div", {
                                        staticClass: "row-item",
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.datosComparativa.OS
                                              .altaserfecha_instala
                                          )
                                        }
                                      }),
                                      _c("div", {
                                        staticClass: "row-item",
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.datosComparativa.CRM
                                              .fecha_instalacion
                                          )
                                        }
                                      }),
                                      _c("div", { staticClass: "row-item" })
                                    ]),
                                    _c("div", { staticClass: "table-row" }, [
                                      _c("div", { staticClass: "row-item" }, [
                                        _vm._v("Tipo Dispositivo")
                                      ]),
                                      _c("div", {
                                        staticClass: "row-item",
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.datosComparativa.OS
                                              .producto_orden
                                          )
                                        }
                                      }),
                                      _c("div", {
                                        staticClass: "row-item",
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.datosComparativa.CRM.tipo_equipo
                                          )
                                        }
                                      }),
                                      _c("div", { staticClass: "row-item" })
                                    ])
                                  ])
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "v-layout",
                        {
                          staticClass: "ma-0 pa-0 mb-5",
                          attrs: {
                            row: "",
                            wrap: "",
                            "align-center": "",
                            "justify-center": ""
                          }
                        },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm3: "", md3: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  label: "Categoría",
                                  "item-text": "name",
                                  items: _vm.categorias,
                                  "item-value": "id",
                                  "prepend-icon": "home_repair_service"
                                },
                                model: {
                                  value: _vm.selectedCategoria,
                                  callback: function($$v) {
                                    _vm.selectedCategoria = $$v
                                  },
                                  expression: "selectedCategoria"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm5: "", md5: "" } },
                            [
                              _c("v-textarea", {
                                attrs: {
                                  label: "Glosa",
                                  "auto-grow": "",
                                  rows: "1",
                                  value: _vm.detalleglosa
                                },
                                on: { input: _vm.onGlosaInput }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm2: "", md2: "" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "#ffe800" },
                                  on: {
                                    click: function($event) {
                                      return _vm.showConfirmation(
                                        "guardarGlosa"
                                      )
                                    }
                                  }
                                },
                                [_vm._v("Guardar Glosa")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          ),
          _c(
            "h2",
            {
              staticClass: "h2_title mb-1",
              staticStyle: {
                "text-align": "center",
                "margin-left": "0",
                "padding-left": "0",
                "font-weight": "normal"
              }
            },
            [_vm._v("\n      Lista de EPC Registrados en CRM\n    ")]
          ),
          _c("v-divider"),
          _c(
            "v-flex",
            {
              attrs: {
                sm12: "",
                md12: "",
                layout: "",
                "justify-end": "",
                "align-center": "",
                "mt-3": "",
                "mb-4": ""
              }
            },
            [
              _c(
                "v-btn",
                {
                  attrs: { flat: "", small: "", color: "primary" },
                  on: { click: _vm.getCSV }
                },
                [
                  _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                    _vm._v("cloud_download")
                  ]),
                  _vm._v("\n          \n        "),
                  _c("span", { staticClass: "importExportBtnTexto" }, [
                    _vm._v("Exportar"),
                    _c("br"),
                    _vm._v("CSV")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c("MantenedorGridVerDetalle", {
            staticClass: "ag-theme-material",
            attrs: {
              "grid-options": _vm.gridOptions,
              funcionalidadId: _vm.funcionalidad
            },
            on: {
              gridOptionsEnriched: function($event) {
                _vm.enrichedGridOptions = $event
              }
            }
          }),
          _vm.showPopUpReport
            ? _c("PopUpGeneratedReports", {
                attrs: { text: _vm.msgReport },
                on: { cerrar: _vm.handleCloseReport }
              })
            : _vm._e()
        ],
        1
      ),
      _c("Confirmation", {
        attrs: {
          show: _vm.showDialog,
          titulo: _vm.confirmationTitle,
          mensaje: _vm.confirmationMessage,
          textoBtnSi: _vm.$t("Confirmar"),
          textoBtnNo: _vm.$t("Cancelar")
        },
        on: { modalConfirmationEmit: _vm.handleConfirmationResponse }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }